/* eslint-disable unicorn/filename-case */

export interface PreventiveMEEntity {
  id: string;
  location: string;
  name: string;
  link: string;
  type: "DAILY" | "QUARTERLY";
}

export namespace PreventiveMEEntity {
  export function fromJSON(data: any): PreventiveMEEntity {
    return {
      id: data.preventiveMEID,
      link: data.preventiveMEUrl,
      location: data.locationID,
      name: data.preventiveMEName,
      type: data.category,
    };
  }

  export function fromArrayJSON(data: any[]): PreventiveMEEntity[] {
    return data.map((e): PreventiveMEEntity => PreventiveMEEntity.fromJSON(e));
  }
}
